module.exports = "../images/devices.jpg";